import React from 'react';
import'./Testimonial.css';
import AVTR1 from'../../assets/avatar1.jpg'
import AVTR2 from'../../assets/avatar2.jpg'
import AVTR3 from'../../assets/avatar3.jpg'
import AVTR4 from'../../assets/avatar4.jpg'

// import Swiper core and required modules
import { Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';







const data =[
{
    avatar:AVTR1,
    name:'John Doe',
    review:'I am John Doe. She is really a amazing designer and developer. Her Design and development is uniq. She is really a dedicated and passionate Developer.In Projects she uses good design and high security develoment.'
},
{
    avatar:AVTR2,
    name:'Robert Browning',
    review:'I am Robert Browning. She is really a amazing designer and developer. Her Design and development is uniq. She is really a dedicated and passionate Developer.In Projects she uses good design and high security develoment.'

},
{
    avatar:AVTR3,
    name:'Elezabeth Beret Browning',
    review:'I am Elezabeth Beret Browning. She is really a amazing designer and developer. Her Design and development is uniq. She is really a dedicated and passionate Developer.In Projects she uses good design and high security develoment.'

},
{
    avatar:AVTR4,
    name:'William Blake',
    review:'I am William Blake. She is really a amazing designer and developer. Her Design and development is uniq. She is really a dedicated and passionate Developer.In Projects she uses good design and high security develoment.'

},
{
    avatar:AVTR2,
    name:'Daniel Brown',
    review:'I am Daniel Brown. She is really a amazing designer and developer. Her Design and development is uniq. She is really a dedicated and passionate Developer.In Projects she uses good design and high security develoment.'

},

]

const Testimonial = () => {
    return (
        <section id='testimonial'>
            <h5>Review From Others</h5>
            <h2>Testimonial</h2>
            <Swiper className="container testimonial_container"
              // install Swiper modules
      modules={[ Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      scrollbar={{ draggable: true }}
      onSwiper={(swiper) => console.log(swiper)}
      onSlideChange={() => console.log('slide change')}
            >
               
               {
                data.map(({avatar,name,review},index) =>{
                    return(
                        <SwiperSlide key={index} className='testimonial'>
                        <div className="client_avatar">
                            <img src={avatar} alt="" />
                        </div>
                        <h5 className='client_name'>{name} </h5>
                            <small className='client_review'>
                               {review}
                            </small>
                    </SwiperSlide>
                    )
                })
               }






                {/* <article className='testimonial'>
                    <div className="client_avatar">
                        <img src={AVTR1} alt="" />
                    </div>
                    <h5 className='client_name'>Ernest Achiever </h5>
                        <small className='client_review'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci cupiditate illum doloremque molestias, nemo quaerat commodi maxime quo qui similique quas dolore harum. Incidunt, temporibus esse aliquid iste molestias reiciendis.
                        </small>
                </article>
                <article className='testimonial'>
                    <div className="client_avatar">
                        <img src={AVTR1} alt="" />
                    </div>
                    <h5 className='client_name'>Ernest Achiever </h5>
                        <small className='client_review'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci cupiditate illum doloremque molestias, nemo quaerat commodi maxime quo qui similique quas dolore harum. Incidunt, temporibus esse aliquid iste molestias reiciendis.
                        </small>
                </article>
                <article className='testimonial'>
                    <div className="client_avatar">
                        <img src={AVTR1} alt="" />
                    </div>
                    <h5 className='client_name'>Ernest Achiever </h5>
                        <small className='client_review'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci cupiditate illum doloremque molestias, nemo quaerat commodi maxime quo qui similique quas dolore harum. Incidunt, temporibus esse aliquid iste molestias reiciendis.
                        </small>
                </article>
                <article className='testimonial'>
                    <div className="client_avatar">
                        <img src={AVTR1} alt="" />
                    </div>
                    <h5 className='client_name'>Ernest Achiever </h5>
                        <small className='client_review'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci cupiditate illum doloremque molestias, nemo quaerat commodi maxime quo qui similique quas dolore harum. Incidunt, temporibus esse aliquid iste molestias reiciendis.
                        </small>
                </article>
                <article className='testimonial'>
                    <div className="client_avatar">
                        <img src={AVTR1} alt="" />
                    </div>
                    <h5 className='client_name'>Ernest Achiever </h5>
                        <small className='client_review'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci cupiditate illum doloremque molestias, nemo quaerat commodi maxime quo qui similique quas dolore harum. Incidunt, temporibus esse aliquid iste molestias reiciendis.
                        </small>
                </article> */}
             
            </Swiper>
        </section>
    );
};

export default Testimonial;